import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import Switch from '@mui/material/Switch';
import { PROJECT_TIMELINE_RECORD_FILTER_OPTIONS, PROJECT_TIMELINE_RECORD_FILTER_TYPE } from './constants';
import { DropDownFilter, FilterInputDecorator, useFilterContext } from 'framework/list';
import { FilterCondition } from 'framework/types';
import { EnumDropdown } from 'framework/form';
import { UiThemeOverrider } from 'framework/uiTheme';
import { PersonTimelineFilterButtonLayout } from 'domain/shared/timeline';

interface ProjectTimelineRecordTypeFilterProps {
  cleanableFilters: any[];
  source: string;
}

const ProjectTimelineRecordTypeFilter = ({
  cleanableFilters,
  source,
  ...props
}: ProjectTimelineRecordTypeFilterProps) => {
  const { filterBy, quickFilter, clearAndApplyFilter, filters: contextFilters } = useFilterContext();
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    const typeFilter = contextFilters?.[source]?.[FilterCondition.IN];
    setIsChecked(!typeFilter || typeFilter.length === 0);
  }, [contextFilters, source]);

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    if (checked) {
      clearAndApplyFilter([...cleanableFilters, source]);
    } else {
      quickFilter({
        [source]: {
          [FilterCondition.IN]: [PROJECT_TIMELINE_RECORD_FILTER_TYPE.USER_NOTE],
        },
      });
    }
  };

  const onChangeCallback = (filter: any) => {
    const filters = {
      ...filter,
    };

    cleanableFilters.forEach((clearableFilter: string) => {
      filters[clearableFilter] = {};
    });

    filterBy(filters);
  };

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <Typography color="text.secondary">Show all notes</Typography>
        <Switch checked={isChecked} onChange={handleSwitchChange} size="small" />
      </Box>
      <UiThemeOverrider
        overriddenLayouts={{
          DropdownLayout: PersonTimelineFilterButtonLayout,
        }}
      >
        <DropDownFilter {...props} source={source} isSingle onChangeCallback={onChangeCallback}>
          <FilterInputDecorator cleanableFilters={[...cleanableFilters, source]}>
            <EnumDropdown {...props} source={''} options={PROJECT_TIMELINE_RECORD_FILTER_OPTIONS} />
          </FilterInputDecorator>
        </DropDownFilter>
      </UiThemeOverrider>
    </>
  );
};

export default ProjectTimelineRecordTypeFilter;
